export const PREVIEW_IMAGE_PENDING_RETRY_MS = 2500;

const isBlankPreviews = previews => !previews || Object.keys(previews).length === 0;

const hasPendingImage = previews =>
  Object.values(previews || {}).some(preview => preview?.imagePending);

/**
 * Decide whether a chat bubble should fetch link previews now and/or schedule
 * one delayed follow-up. Attachment messages stay on the existing skip.
 * `retried` must flip to true after the delayed call so `imagePending`
 * updates cannot start another immediate fetch.
 */
export default function messagePreviewPollPlan({ text, attachments, previews, retried }) {
  if (!text || attachments?.length) {
    return { fetchNow: false, scheduleRetry: false };
  }
  const empty = isBlankPreviews(previews);
  const pending = hasPendingImage(previews);
  if (!empty && !pending) {
    return { fetchNow: false, scheduleRetry: false };
  }
  return {
    fetchNow: empty,
    scheduleRetry: !retried,
  };
}
